'use strict';

var _jquery = require('./lib/jquery-3.3.1.min');

var _jquery2 = _interopRequireDefault(_jquery);

var _service = require('./service');

var _service2 = _interopRequireDefault(_service);

var _tips = require('./tips');

var _tips2 = _interopRequireDefault(_tips);

var _util = require('./util/util');

var _scroll = require('./util/scroll');

var _scroll2 = _interopRequireDefault(_scroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var booking = {
    data: {
        phone: 0,
        phone_code: 0,
        countDown: 0,
        area: '台灣',
        shouldShowPopup: 1,
        hasInit: false,
        hasSelectTiaoKuan: true
    },
    init: function init() {
        this.getLoginStatus();
        this.getBookingInfo();
        this.bindEvent();
        this.listenResize();
    },
    bindEvent: function bindEvent() {
        var _this = this;

        (0, _jquery2["default"])('.get-verifycode').click(function () {
            if (!_this.data.hasSelectTiaoKuan) {
                alert('請先閱讀并同意服務條款噢');
                return;
            }
            if (!_this.data.hasLogin) {
                alert(_tips2["default"][-1]);
                window.location.href = _util.config.url.login;
            } else {
                if (_this.data.countDown && _this.data.shouldShowPopup) {
                    _this.popupBooking();
                } else {
                    _this.getBookingInfo();
                }
            }
        });
        (0, _jquery2["default"])('.popup-close').click(function () {
            _this.hideBooking();
        });
        (0, _jquery2["default"])('.j-check-tiaokuan').click(function () {
            _this.data.hasSelectTiaoKuan = !_this.data.hasSelectTiaoKuan;
        });
        (0, _jquery2["default"])('.j-read-tiaokuan').click(function () {
            alert('本人同意G妹遊戲使用我提供的手機號碼，接收有關G妹遊戲的任何遊戲、活動等資訊。如你日後希望停止接收上述資訊，或更改個人資料，請連同您已登記的姓名、手機號碼等資料，電子郵件至service@gm99.com或到G妹遊戲平台上聯繫客服通知我們。');
        });

        (0, _jquery2["default"])('.phone-number').click(function () {
            if (!_this.data.hasLogin) {
                alert(_tips2["default"][-1]);
                window.location.href = _util.config.url.login;
            }
        });

        (0, _jquery2["default"])('.j-count-down').click(function () {
            _this.doGetVeirfyCode();
        });

        (0, _jquery2["default"])('.do-booking').click(function () {
            _this.doBooking();
        });
    },
    getVerifyCode: function getVerifyCode() {
        var area = (0, _jquery2["default"])('.j-phone-code option:selected').text();
        this.data.area = area.substring(0, area.indexOf(' '));
        var phone = _jquery2["default"].trim((0, _jquery2["default"])('.phone-number').val());
        if (!_util.validate.isPhoneNumber(this.data.area, phone)) {
            alert(_tips2["default"]['errNumber']);
            return;
        }

        this.doGetVeirfyCode();
    },
    getBookingInfo: function getBookingInfo() {
        var _this2 = this;

        _service2["default"].getBookingInfo(function (res) {
            _this2.renderBookingProgress(res.data.total_reserved_num);
            if (res.data.IS_RESERVED) {
                window.IS_RESERVED = 1;
            } else {
                window.IS_RESERVED = 0;
            }
            if (_this2.data.hasInit) {
                if (!res.data.IS_RESERVED) {
                    _this2.getVerifyCode();
                } else {
                    alert(_tips2["default"]['IS_RESERVED']);
                }
            }
            _this2.data.hasInit = true;
        }, function (err) {
            console.log(err);
        });
    },
    renderBookingProgress: function renderBookingProgress(totalCount) {
        (0, _jquery2["default"])('.j-total-booking').html(totalCount + '人');
        if (totalCount >= 80000) {
            this.addClass('x2');
        }
        if (totalCount >= 150000) {
            this.addClass('x3');
        }
        if (totalCount >= 200000) {
            this.addClass('x5');
        }
    },
    addClass: function addClass(target) {
        (0, _jquery2["default"])('.j-process-' + target).addClass('process-active');
        (0, _jquery2["default"])('.j-bar-' + target).addClass('bar-active');
    },
    doGetVeirfyCode: function doGetVeirfyCode() {
        var _this3 = this;

        var params = {
            'phone': _jquery2["default"].trim((0, _jquery2["default"])('.phone-number').val()),
            'phone_code': (0, _jquery2["default"])('.j-phone-code').val()
        };
        _service2["default"].getVerifyCode(params, function (res) {
            if (!res.result) {
                alert(_tips2["default"][res.code] || res.msg);
                return;
            } else {
                _this3.popupBooking();
                _this3.countDown();
            }
        }, function (err) {
            console.log(err);
        });
    },
    countDown: function countDown() {
        var _this4 = this;

        var $countDown = (0, _jquery2["default"])('.j-count-down');
        $countDown.addClass('disabled');

        var time = 60;
        var timer = setInterval(function () {
            if (time <= 0) {
                _this4.data.countDown = 0;
                $countDown.attr('disabled', false);
                $countDown.removeClass('disabled');
                $countDown.text('重新獲取');
                clearInterval(timer);
            } else {
                time--;
                _this4.data.countDown = time;
                $countDown.text(time + 's');
                $countDown.attr('disabled', true);
            }
        }, 1000);
    },
    popupBooking: function popupBooking() {
        (0, _jquery2["default"])('html, body').addClass('unscroll');
        var $bookingPopup = (0, _jquery2["default"])('.booking-popup');
        $bookingPopup.height((0, _jquery2["default"])(window).height());
        $bookingPopup.width((0, _jquery2["default"])(window).width());
        $bookingPopup.fadeIn();
    },
    hideBooking: function hideBooking() {
        (0, _jquery2["default"])('html, body').removeClass('unscroll');
        (0, _jquery2["default"])('.booking-popup').fadeOut();
    },
    listenResize: function listenResize() {
        window.addEventListener('resize', function () {
            var $bookingPopup = (0, _jquery2["default"])('.booking-popup');
            $bookingPopup.height((0, _jquery2["default"])(window).height());
            $bookingPopup.width((0, _jquery2["default"])(window).width());
        });
    },
    getLoginStatus: function getLoginStatus() {
        var _this5 = this;

        _service2["default"].getLoginStatus(function (res) {
            if (res.result === -1) {
                _this5.data.hasLogin = 0;
            } else {
                _this5.data.hasLogin = 1;
            }
        }, function (err) {
            console.log(err);
        });
    },
    doBooking: function doBooking() {
        var _this6 = this;

        var check_code = _jquery2["default"].trim((0, _jquery2["default"])('.j-check-code').val());
        if (!check_code) {
            alert(_tips2["default"]['no_check_code']);
            return;
        }
        var params = {
            'phone': _jquery2["default"].trim((0, _jquery2["default"])('.phone-number').val()),
            'area': this.data.area,
            'phone_code': (0, _jquery2["default"])('.j-phone-code').val(),
            'check_code': check_code,
            'cid': (0, _util.getUrlParam)('cid'),
            'scid': (0, _util.getUrlParam)('scid')
        };
        _service2["default"].doBooking(params, function (res) {
            if (res.result === 1) {
                alert(_tips2["default"]['bookingS']);
                _this6.hideBooking();
                _this6.data.shouldShowPopup = 0;
                _this6.data.hasInit = false;
                _this6.getBookingInfo();
                var targetHeight = (0, _jquery2["default"])('.top').height() + (0, _jquery2["default"])('.booking').height();
                var currentHeight = (0, _jquery2["default"])(window).scrollTop();
                (0, _scroll2["default"])(currentHeight, targetHeight);
            } else {
                alert(res.msg);
            }
        }, function (err) {
            console.log(err);
        });
    }
};
module.exports = booking;


//////////////////
// WEBPACK FOOTER
// ./src/bsjyy/js/booking.js
// module id = 104
// module chunks = 7 8